<template>
  <div class="has-table-navigations has-table-navigations--left-above"
       :class="{'is-inactive': (!controlsCanScrollToRight && !controlsCanScrollToLeft)}">
    <div class="has-table-navigations-left"
         :class="{'is-active': controlsCanScrollToLeft, 'is-remove': !controlsCanScrollToLeft}"
         @click="scrollToXControls('left')">
        <span class="icon"><i class="fas fa-chevron-left"></i></span>
        <span class="label"><!--<i>Plus d'informations</i>--></span>
    </div>
    <div class="has-table-navigations-right"
         :class="{'is-active': controlsCanScrollToRight, 'is-remove': !controlsCanScrollToRight}"
         @click="scrollToXControls('right')">
        <span class="icon"><i class="fas fa-chevron-right"></i></span>
        <span class="label"><!--<i>Plus d'informations</i>--></span>
    </div>
    <div class="table-wrapper-thead-sticky table-wrapper-thead-sticky--groupcols js-table-wrapper-thead-sticky js-table-wrapper-scroll"
         :style="hasSticky ? stickyStyles : ''" :id="from === 'LeadList' ? '' : 'list'">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import VueScrollTo from 'vue-scrollto'
  import { bus, EVENTS } from '@/services/bus/index.js'
  import { debounce } from 'lodash'

  export default {
    name: 'TableHScroll',
    props: {
      hasSticky: {
        type: Boolean,
        default: false
      },
      stickyStyles: {
        type: Object,
        default: () => {}
      },
      stickyDatas: {
        type: Object,
        default: () => {}
      },
      reloadControls: [Boolean, Array, Object, Number]
    },
    data () {
      return {
        w: window,
        controlsDatas: {
          tableEl: undefined,
          tableWidth: 0,
          scrollLeft: false,
          ticking: false,
          wrapperEl: null,
          wrapperWidth: null
        }
      }
    },
    computed: {
      from () {
        return this.$route.name
      },
      controlsCanScrollToLeft () {
        return !(this.controlsDatas.scrollLeft <= 0)
      },
      controlsCanScrollToRight () {
        // console.log(this.controlsDatas.scrollLeft + this.controlsDatas.wrapperWidth)
        // console.log(this.controlsDatas.tableWidth)
        return (this.controlsDatas.scrollLeft + this.controlsDatas.wrapperWidth) < (this.controlsDatas.tableWidth - 1) // - 1 car décalage de un pixel
      }
    },
    watch: {
      reloadControls (v) {
        return this.tickingControls()
      }
    },
    methods: {
      initControls (wrapperTableEl) {
        let tableEl = wrapperTableEl.querySelector('table')
        this.controlsDatas.wrapperEl = wrapperTableEl // Element wrapper du tableau
        this.controlsDatas.wrapperWidth = wrapperTableEl.offsetWidth // Largeur du wrapper
        this.controlsDatas.tableEl = tableEl // Element wrapper du tableau
        this.controlsDatas.tableWidth = tableEl.offsetWidth // Largeur du tableau
        if (wrapperTableEl === undefined || this.controlsDatas.tableWidth === 0) {
          return false
        }

        // Test si on peut scroller horizontalement
        if (this.controlsDatas.tableWidth <= this.controlsDatas.wrapperWidth) {
          return false
        } else {
          this.calculsControls()
        }

        this.w.addEventListener('resize', this.tickingControls)
        if (this.hasSticky && this.stickyDatas && this.stickyDatas.wrapperTableEl) {
          this.stickyDatas.wrapperTableEl.addEventListener('scroll', this.calculsControls)
        }
      },
      tickingControls: debounce(function () {
        if (!this.controlsDatas.ticking) {
          this.w.requestAnimationFrame(() => {
            this.initControls(this.$el.querySelector('.js-table-wrapper-scroll'))
            this.$set(this.controlsDatas, 'ticking', false)
          })
          this.$set(this.controlsDatas, 'ticking', true)
        }
      }, 300),
      calculsControls () {
        // $(".content").scrollTo("+=150px", 200, {axis: 'x', limit: false})
        if (!this.controlsDatas.wrapperEl) {
          this.controlsDatas.wrapperEl = this.$el.querySelector('.js-table-wrapper-scroll')
        }
        let left = this.controlsDatas.wrapperEl.scrollLeft // Le scroll left
        this.$set(this.controlsDatas, 'scrollLeft', left) // Mise à jour de la position du scroll
      },
      destroyControls () {
        this.w.removeEventListener('resize', this.tickingControls)
        this.$set(this.controlsDatas, 'ticking', false)
        if (this.hasSticky && this.stickyDatas && this.stickyDatas.wrapperTableEl) {
          this.stickyDatas.wrapperTableEl.removeEventListener('scroll', this.calculsControls)
        }
      },
      scrollToXControls (direction = 'right') {
        let offset
        if (direction === 'right') {
          offset = this.controlsDatas.scrollLeft + 250
        } else {
          offset = this.controlsDatas.scrollLeft - 250
        }
        var options = {
          container: this.controlsDatas.wrapperEl,
          easing: 'ease-in',
          offset: offset,
          force: true,
          cancelable: true,
          onStart: (element) => {
            // scrolling started
          },
          onDone: (element) => {
            // scrolling is done
            this.calculsControls()
          },
          onCancel: () => {
            // scrolling has been interrupted
            this.calculsControls()
          },
          x: true,
          y: false
        }
        VueScrollTo.scrollTo(this.controlsDatas.tableEl, 100, options)
      }
    },
    mounted () {
      this.tickingControls()
      bus.$on(EVENTS.RESIZE_TABLE, this.tickingControls)
    },
    destroyed () {
      this.destroyControls()
      bus.$off(EVENTS.RESIZE_TABLE)
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/utils/TableHScroll.vue